export var getContenidoTipoFuncionAbrirEjercicioGG = function getContenidoTipoFuncionAbrirEjercicioGG(state, zona) {
  var params = zona.vinculo.split(':')[1];

  var _params$split = params.split('.'),
      plantillaId = _params$split[0],
      fcs = _params$split.slice(1);

  var contenido = {
    tipo: 'funcion,abrirEjercicioGG',
    src: 'contenido/GG/ejercicio.html?&curso=curso&res=res&plantillaId=' + plantillaId + '&fcs=' + fcs // window.console.log("getContenidoTipoFuncionAbrirEjercicioGG zona, contenido", zona, contenido)

  };
  return contenido;
};